var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},_vm._l((_vm.displayCurrencies),function(item){return _c('el-button',{key:item.currency,staticClass:"purple_button",attrs:{"data-testid":item.currency}},[_vm._v(" "+_vm._s(item.value)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }